/**
 * Round 18 L10 -- name the members of a frozen MVB set by class and
 * admission.
 *
 * The in-force declaration headed its frozen snapshot "IBSes" over six
 * names -- Treasury settlement (a function) and two candidates among
 * them -- and home's card read "IBSes in MVB set 6". The backend reads
 * each member's class and admission from the register today
 * (`members_now`); this turns it into one sentence for both surfaces.
 */
import type { TFunction } from "i18next";

import { listOf } from "shared/i18n/listOf";

export interface MembersNow {
  members: number;
  admitted_services: number;
  candidates: number;
  functions: number;
  functions_admitted?: number;
  removed: number;
  unknown?: number;
  by_id?: Record<
    string,
    { service_class: string | null; admission_status: string | null }
  >;
}

/** The sentence, or null when every member is an admitted service (the
 *  set then reads as it always did: "6 IBSes"). */
export function membersSentence(
  m: MembersNow | null | undefined,
  t: TFunction,
): string | null {
  if (!m || typeof m.members !== "number") return null;
  if (m.admitted_services === m.members) return null;
  const base = "mvbMembers";
  const parts = [
    m.admitted_services > 0 &&
      t(`${base}.admittedServices`, { count: m.admitted_services }),
    m.candidates > 0 && t(`${base}.candidates`, { count: m.candidates }),
    m.functions > 0 && t(`${base}.functions`, { count: m.functions }),
    m.removed > 0 && t(`${base}.removed`, { count: m.removed }),
  ].filter((x): x is string => typeof x === "string");
  return t(`${base}.sentence`, { count: m.members, parts: listOf(parts) });
}
